import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast
} from "@chakra-ui/react";
import { appRequest } from "routes";

type ModalProps = {
  isOpen: boolean;
  isUser?: boolean;
  isProjects?: boolean;
  isRole?: boolean;
  onClose: () => void;
  handleUpdate: () => void;
  id?: string;
  request: {
    type: string;
    requestType: string;
  }
};

export default function DeleteModal({
  isOpen,
  onClose,
  isUser,
  isProjects,
  isRole,
  id,
  request,
  handleUpdate
}: ModalProps): JSX.Element {
  const toast = useToast()

  const handleDelete = async () => {
    let type = isUser ? 'User' : isRole ? 'Role' : 'Project'
    try {
      const response: any = await appRequest(request?.type, request?.requestType, { id: id })
      if (response) {
        if(response.status === 'success'){
          toast({
            title: `${type} deleted successfully.`,
            description: `We've deleted your ${type}.`,
            status: response.status,
            duration: 9000,
            isClosable: true,
            position: 'top-right'
          })
          handleUpdate()
          onClose()
        }else{
          toast({
            title: `Error Deleting the ${type}.`,
            description: response.code || response.message,
            status: "error",
            duration: 9000,
            isClosable: true,
            position: 'top-right'
          });
        }

      }else{
        toast({
          title: `Error Deleting the ${type}.`,
          description: response.message,
          status: "error",
          duration: 9000,
          isClosable: true,
          position: 'top-right'
        });
      }

    } catch (error: any) {
      toast({
        title: `Error Deleting the ${type}.`,
        description: error.message || "Something went wrong.",
        status: 'error',
        duration: 9000,
        isClosable: true,
        position: 'top-right'
      })
    }
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{base:"sm", md:"md"}} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="500"
            color="red"
            mt={10}
            textAlign="center"
          >
            This action cannot be undone. Deleting this{" "}
            {isUser && <Text as="span">user</Text>}{" "}
            {isRole && <Text as="span">role</Text>}{" "}
            {isProjects && <Text as="span">projects</Text>} will remove all
            associated permissions.
          </Text>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="700"
            color="red"
            mt={1}
            textAlign="center"
          >
            Please confirm?
          </Text>
        </ModalBody>

        <ModalFooter
          gap={6}
          mt={2}
          justifyItems="center"
          justifyContent="center"
          my={6}
        >
          <Button
            type="submit"
            w="70px"
            bg="teal.300"
            color="white"
            _hover={{
              bg: "teal.400",
            }}
            onClick={handleDelete}
          >
            Yes
          </Button>
          <Button onClick={onClose} colorScheme="red" color="white" w="70px">
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
